import HeaderDashboard from '../../Components/HeaderDashboard'
import React, { useEffect, useState, useRef, useContext } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../Routes/AuthProvider"
import { FlightBookingDetails, SmsRequest, WhatsAppRequest, TicketDownload, GetTravelDocuments } from "../../Services/API";
import EmailTicket from './EmailTicket';
import SmsTicket from './SmsTicket';
import WhatsAppTicket from './WhatsAppTicket';
import TravelDocument from './TravelDocument';
import {FlightTransactionDetails} from "../../Services/API";

const TransactionDetails = () => {
  const { name, userName, roles, corporateId } = useContext(AuthContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referenceNo = queryParams.get("referenceNo");
  const trackId = queryParams.get("trackID");

  const [flightDetails, setFlightDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (referenceNo && trackId) {
      fetchFlightBookingDetails(referenceNo, trackId);
    } else {
      console.warn("Missing referenceNo and trackId");
    }
  }, [referenceNo, trackId]);

  const fetchFlightBookingDetails = async (referenceNo, trackId) => {
    try {
      setLoading(true);
      setError("");
      const params = { ReferenceNo: referenceNo, TrackID: trackId, ClientCode: "BerryJourneys", Key: "", SessionID: "" };
      //const response = await FlightBookingDetails(params);
      const response = await FlightTransactionDetails(params);
      setFlightDetails(response);
      console.log(response.status)


    } catch (err) {
      setError("Failed to load flight Booking details. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const gstRequest = flightDetails?.gstRequest || {};

  // const handleTicketdownload = async () => {
  //   try {
  //     setLoading(true);
  //     const reqParms = {
  //       referenceNo: flightDetails?.referenceNo,
  //       trackId: flightDetails?.airBookingResponse[0]?.flightDetails[0]?.trackID,
  //       type: "Ticket"
  //     };

  //     const response = await TicketDownload(reqParms);

  //     if (response && response.data) {
  //       const blob = new Blob([response.data], {
  //         type: "application/pdf",
  //       });

  //       const url = window.URL.createObjectURL(blob);
  //       const link = document.createElement("a");
  //       link.href = url;

  //       const contentDisposition = response.headers["content-disposition"];
  //       let fileName = "ETicket.pdf";

  //       if (contentDisposition) {
  //         const match = contentDisposition.match(/filename="?(.+)"?/);
  //         if (match?.[1]) fileName = match[1];
  //       }

  //       link.setAttribute("download", fileName);
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //     } else {
  //       alert("Failed to download ticket.");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     alert("Error downloading ticket.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleTicketdownload = async () => {
    alert(
      "Please select 'Save as PDF' in the print dialog to download your voucher.",
    );
    handlePrintTicket();
  };

  const handlePrintTicket = () => {
    const url = `/reservations/flight/PrintTicket?ReferenceNo=${flightDetails?.referenceNo}&trackID=${flightDetails?.airBookingResponse?.[0]?.trackID ?? ""}`;
    const printWindow = window.open(url, "_blank");

    if (printWindow) {
      printWindow.focus();
    }
  };

  const handleInvoiceTicket = () => {
    const url = `/reservations/flight/PrintInvoice?ReferenceNo=${flightDetails.referenceNo}&trackID=${flightDetails?.airBookingResponse?.[0]?.trackID ?? ""}`;
    const printWindow = window.open(url, "_blank");

    if (printWindow) {
      printWindow.focus();
    }
  };

  const [documents, setDocuments] = useState([]);
  const [showDocuments, setShowDocuments] = useState(false);
  const [loadingDocuments, setLoadingDocuments] = useState(false);

  const handleGetDocuments = async () => {
    try {
      setLoadingDocuments(true);

      const request = {
        ReferenceNo: flightDetails?.referenceNo,
        ProductType: "Flight",
      };

      const result = await GetTravelDocuments(request);
      console.log("GetTravelDocuments", result);
      setDocuments(result || []);
      setShowDocuments(true);
    } catch (error) {
      console.error(error);
      setDocuments([]);
      setShowDocuments(true);
    } finally {
      setLoadingDocuments(false);
    }
  };

  return (
    <>
      {loading && (
        <p class="text-center load"><span class="loader"></span></p>
      )}
      <HeaderDashboard></HeaderDashboard>
      <div className="toolbar py-2" id="kt_toolbar">
        <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
          <div className="flex-grow-1 flex-shrink-0 me-5">
            <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
              <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Reservations</h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li class="breadcrumb-item text-muted">Flight</li>
                <li class="breadcrumb-item">
                  <span class="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Reservations/Flight/AllTransactions" className="text-muted text-hover-primary">All Transactions</a>
                </li>

                <li class="breadcrumb-item">
                  <span class="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Reservations/Flight/AllTransactions" className="breadcrumb-item text-gray-900">Transaction Details</a>
                </li>

              </ul>
            </div>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <div class="flex-shrink-0 me-2 d-none-mob">
              <ul class="nav" role="tablist">
                <li class="nav-item" role="presentation">
                  <a href="#" onClick={(e) => { e.preventDefault(); window.history.back(); }} >
                    <img src="/assets/images/back.png" width={30} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <section className='wraper'>
        <div className='box_shadow mt-14'>
          {/* flightDetails.status ==="Confirmed" && */}

          {loading && (
            <div class="row mamage_depo">
              <div class="col-lg-12">
                <h6 className='ruler'>Flight Booking Details</h6>
              </div>
              <div class="col-lg-12">
                <p className=''>Loading Flight Booking Details...</p>
              </div>
            </div>
          )}

          {flightDetails && flightDetails.airBookingResponse.length > 0 ? (
            <>
              <div class="row mamage_depo">
                {flightDetails?.airBookingResponse?.[0]?.isVipUser === true && (
                  <div class="alert alert-success" role="alert">
                    <strong>VIP Booking!</strong> This booking belongs to a VIP user.
                  </div>
                )}
                <div class="col-lg-6">
                  <h6 className='ruler'>Flight Booking Details</h6>
                </div>
                {flightDetails.airBookingResponse[0].bookingStatus === "Confirmed" && (
                  <div class="col-lg-6 text-right">
                    <ul className='option_s'>
                      <li>
                        <button
                          type="button"
                          onClick={() => {
                            window.open(
                              `/reservations/flight/PrintTicket?ReferenceNo=${flightDetails?.referenceNo ?? ""}&trackID=${flightDetails?.airBookingResponse?.[0]?.trackID ?? ""}`,
                              "_blank"
                            );
                          }}
                          style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                          title="Print Ticket"
                        >
                          <img
                            src="/assets/images/printer.png"
                            alt="Print Ticket"
                          />
                        </button>
                      </li>


                      <li>
                        <button
                          type="button"
                          onClick={() => {
                            window.open(
                              `/reservations/flight/PrintInvoice?ReferenceNo=${flightDetails.referenceNo}&trackID=${flightDetails?.airBookingResponse?.[0]?.trackID ?? ""}`,
                              "_blank",
                            );
                          }}
                          style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                          title="Invoice"
                        >
                          <img
                            src="/assets/images/Invoice.png"
                            alt="Invoice"
                          />
                        </button>
                      </li>
                      <li>
                        <button
                          type="button"
                          onClick={handleTicketdownload}
                          style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                          title="Download Ticket"
                        >
                          <img
                            src="/assets/images/download.png"
                            alt="Download Ticket"
                          />
                        </button>
                        {/* <button
                          type="button"
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = `/reservations/flight/PrintTicket?ReferenceNo=${flightDetails.referenceNo}&trackID=${flightDetails?.airBookingResponse?.[0]?.trackID ?? ""}`;
                            link.download = "DownloadTicket.pdf";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }}
                          style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                          title="Download Ticket"
                        >
                          <img
                            src="/assets/images/download.png"
                            alt="Download Ticket"
                          />
                        </button> */}
                      </li>
                      <li><a href={`/reservations/flight/ReSchedule?ReferenceNo=${flightDetails.referenceNo}&trackID=${flightDetails?.airBookingResponse?.[0]?.trackID ?? ""}`}>
                        <img src="/assets/images/ticket.png" title='Re-Schedule Request' alt="Re-Schedule Request" /> </a>
                      </li>
                      <li><a href={`/reservations/flight/CancellationBooking?ReferenceNo=${flightDetails.referenceNo}&trackID=${flightDetails?.airBookingResponse?.[0]?.trackID ?? ""}`}>
                        <img src="/assets/images/ticket.png" title='Cancel Booking' alt="Cancel Booking" /></a>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              <div className='col-md-12 col-lg-12'>
                <table className="table table-bordered responsive-table">
                  <thead>
                    <tr>
                      <th>Reference No</th>
                      <th>Confirmation Number (PNR)</th>
                      <th>Booking Status</th>
                      <th>Ticketing Status</th>
                      <th>Booking Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td data-label="Reference No">{flightDetails.referenceNo}</td>
                      <td data-label="PNR">{flightDetails.airBookingResponse[0].pnr}</td>
                      <td>
                        <span
                          style={{
                            color: flightDetails.airBookingResponse[0].bookingStatus === "Confirmed" ? "green" : "red",
                          }}
                        >
                          <b>{flightDetails.airBookingResponse[0].bookingStatus}</b>
                        </span>
                      </td>
                      <td>
                        <span
                          style={{
                            color: flightDetails.airBookingResponse[0].ticketingStatus === "Confirmed" ? "green" : "red",
                          }}
                        >
                          <b>{flightDetails.airBookingResponse[0].ticketingStatus}</b>
                        </span>
                      </td>
                      {/* <span
                                                    style={{
                                                        color: item.ticketingStatus === "Confirmed" ? "green" : "red",
                                                        backgroundColor:
                                                            item.ticketingStatus === "Confirmed" ? "#d4edda" : "#f8d7da",
                                                        padding: "2px 8px",
                                                        borderRadius: "14px",
                                                        fontSize: "14px",
                                                        display: "inline-block",
                                                    }}
                                                >
                                                    <b>{item.ticketingStatus}</b>
                                                </span> */}
                      {/* <td data-label="Booking Status">{flightDetails.airBookingResponse[0].bookingStatus}</td>
                      <td data-label="Ticketing Status">{flightDetails.airBookingResponse[0].ticketingStatus}</td> */}
                      <td data-label="Booking Date">
                        {new Date(flightDetails.airBookingResponse[0].bookingDate)
                          .toLocaleString("en-IN")}
                      </td>
                    </tr>
                  </tbody>
                </table>


              </div>
              <div className='col-md-12 col-lg-12'>
                <h6 className='ruler'>Travel Information</h6>
                <div className='table-responsive'>
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Travel Date</th>
                        <th>Airline</th>
                        <th>Flight No.</th>
                        <th>Aircraft Type</th>
                        <th>From / Terminal </th>
                        <th>To / Terminal</th>
                        <th>Dep Time</th>
                        <th>Arr Time</th>
                      </tr>
                      {flightDetails?.airBookingResponse?.map((bookingResponse, bookingIndex) => (
                        bookingResponse?.flightDetails?.map((flight, flightIndex) => (
                          <tr key={`${bookingIndex}-${flightIndex}`}>
                            <td>
                              {new Date(flight.departDateTime).toLocaleDateString("en-US", {
                                weekday: "short",
                                day: "2-digit",
                                month: "short",
                                year: "numeric"
                              }).replace(",", " ,")}
                            </td>
                            {/* <td>{flight.DepartDateTime}</td> */}
                            <td>{flight.airLineName}</td>
                            <td>{flight.airLineCode} - {flight.flightNumber}</td>
                            <td><samp>N/A</samp></td>
                            <td class="dropdown-caps">{flight.departAirportCode} <span> :{flight.departTerminal}</span></td>

                            <td class="dropdown-caps">{flight.arrivalAirportCode} <span> :{flight.arrivalTerminal}</span></td>
                            <td>
                              {new Date(flight.departDateTime).toLocaleString("en-GB", {
                                weekday: "short",
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </td>

                            <td>
                              {new Date(flight.arrivalDateTime).toLocaleString("en-GB", {
                                weekday: "short",
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </td>
                          </tr>
                        ))
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <h4 className='headings'>Travel Policy</h4>
                </div>
                <div className='col-md-6'>
                  <div class="d-flex mb-3">
                    <div class="labl">Policy Status </div>
                    <div
                      className="labl_detls"
                      style={{
                        color: flightDetails.airBookingResponse[0]?.policyStatus === "OutOfPolicy" ? "red" : "green",
                        fontWeight: "600"
                      }}
                    >
                      {flightDetails.airBookingResponse[0]?.policyStatus || "-"}
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div class="d-flex mb-3">
                    <div class="labl">Policy Reason </div>
                    <div className="labl_detls" style={{ color: "red" }}>{flightDetails.airBookingResponse[0]?.policyReason || "-"}</div>
                  </div>
                </div>
              </div>
              {flightDetails.airBookingResponse[0].bookingStatus === "Confirmed" && (
                <div className='col-md-12 col-lg-12 mb-12'>
                  <h6 className='ruler'>Cart Amendments</h6>
                  <div className='row'>
                    <div className="col-md-3">
                      <div className='box_shadows text-left'>

                        <a
                          type="button"
                          onClick={handlePrintTicket}
                          style={{ background: "none", border: "none", padding: 0 }}
                        >
                          <h5><img src="/assets/images/printer.png" title='Print Ticket' alt="Print Ticket" /> Print Ticket</h5>
                          <p>Print your ticket for travel, Get a printable copy of your ticket</p>
                          <button className='btn-raise'>Print Ticket</button>
                        </a>
                      </div>
                    </div>


                    <div className="col-md-3">
                      <div className="box_shadows">
                        <div
                          onClick={handleInvoiceTicket}
                          // onClick={() => {
                          //   window.open(
                          //     `/reservations/flight/PrintInvoice?ReferenceNo=${flightDetails.referenceNo}`,
                          //     "_blank"
                          //   );
                          // }}
                          style={{ cursor: "pointer" }}
                        >
                          <h5>
                            <img src="/assets/images/Invoice.png" alt="Invoice" /> Invoice
                          </h5>
                          <p>View & Manage the Invoice for flight booking ticket.</p>
                          <button className="btn-raise" type="button">
                            View Invoice
                          </button>
                        </div>
                      </div>

                    </div>


                    <div className="col-md-3">
                      <div className="box_shadows">
                        <div className="w-100 d-block">
                          <h5>
                            <img src="/assets/images/Download.png" alt="Download Ticket" /> Download Ticket
                          </h5>
                          <p>Download the copy of your flight ticket.</p>

                          <button
                            className="btn-raise"
                            type="button"
                            onClick={handleTicketdownload}
                          //</div>onClick={() => {
                          // const link = document.createElement("a");
                          // link.href = `/reservations/flight/DownloadTicket?ReferenceNo=${flightDetails.referenceNo}`;
                          // link.download = "Ticket.pdf";
                          // document.body.appendChild(link);
                          // link.click();
                          // document.body.removeChild(link);
                          //}}
                          >
                            Download
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className='col-md-3'>
                      <div className='box_shadows'>
                        <a href='' data-bs-toggle="modal" data-bs-target="#EmailTicket" className=''>
                          <h5><img src="/assets/images/email.png" title='Cancel Booking' alt="Cancel Booking" /> Email Ticket</h5>
                          <p>Email the copy of ticket on my Email Address.</p>
                          <button className='btn-raise'>Email Ticket</button>
                        </a>
                      </div>
                    </div>

                    <div className='col-md-3'>
                      <div className='box_shadows'>
                        <a href='' data-bs-toggle="modal" data-bs-target="#SMSTicket" className=''>
                          <h5><img src="/assets/images/sms.png" title='Cancel Booking' alt="SMS Ticket" /> SMS Ticket</h5>
                          <p>Send the Flight ticket on my contact number by SMS.</p>
                          <button className='btn-raise'>SMS Ticket</button>
                        </a>
                      </div>
                    </div>

                    {/*   <div className='col-md-3'>
                      <div className='box_shadows'>
                        <a href='' data-bs-toggle="modal" data-bs-target="#WhatsAppMe" className=''>
                          <h5><img src="/assets/images/whatsapp.png" title='Cancel Booking' alt="WhatsApp Me" /> WhatsApp Me</h5>
                          <p>Send the copy of my ticket on my WhatsApp number.</p>
                          <button className='btn-raise'>WhatsApp Me</button>
                        </a>
                      </div>
                    </div>
*/}
                    <div className='col-md-3'>
                      <div className='box_shadows'>
                        <a href={`/reservations/flight/ReSchedule?ReferenceNo=${flightDetails.referenceNo}&trackID=${flightDetails?.airBookingResponse?.[0]?.trackID ?? ""}`} className=''>
                          <h5><img src="/assets/images/ticket.png" title='Re-Schedule Request' alt="Re-Schedule Request" />Re-Schedule </h5>
                          <p>Modify your booking or change flight dates easily.</p>
                          <button className='btn-raise'>Raise Request</button>
                        </a>
                      </div>
                    </div>

                    <div className='col-md-3'>
                      <div className='box_shadows'>
                        <a href={`/reservations/flight/CancellationBooking?ReferenceNo=${flightDetails.referenceNo}&trackID=${flightDetails?.airBookingResponse?.[0]?.trackID ?? ""}`} className=''>
                          <h5><img src="/assets/images/ticket.png" title='Cancel Booking' alt="Cancel Booking" /> Cancel Booking</h5>
                          <p>Check cancellation charges and refund eligibility before request</p>
                          <button className='btn-raise'>Raise Request</button>
                        </a>
                      </div>
                    </div>

                  </div>
                </div>
              )}
              <div className='col-md-12 col-lg-12'>
                <h6 className='ruler'>Contact Information</h6>
                <div className='table-responsive'>
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Preferred Mobile No</th>
                        <th>Email address </th>
                      </tr>
                      <tr valign="top">
                        <td>
                          <div id="phone">
                            {flightDetails.airBookingResponse[0].mobileCountryCode} {flightDetails.airBookingResponse[0].customerInfo.mobile}
                          </div>
                        </td>
                        <td>
                          <div id="phone">{flightDetails.airBookingResponse[0].customerInfo.email}</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='col-md-12 col-lg-12'>
                <h6 className='ruler'>Passenger Information</h6>
                <div className='table-responsive'>
                  <table class="table table-bordered hide--mobile">
                    <tbody>
                      <tr>
                        <th>S.No</th>
                        <th>Passenger Name</th>
                        <th>Pax Type</th>
                        <th>Date of Birth</th>
                      </tr>
                      {flightDetails?.airBookingResponse?.[0]?.customerInfo?.passengerDetails?.map((pax, index) => (
                        <tr key={index} valign="top">
                          <td>{index + 1}.</td>
                          <td style={{ textTransform: "uppercase" }}>
                            {pax.title}. {pax.firstName} {pax.lastName}
                          </td>
                          <td style={{ textTransform: "uppercase" }}>
                            {pax.paxType?.toUpperCase().trim() === "ADT" && "ADULT"}
                            {pax.paxType?.toUpperCase().trim() === "CHD" && "CHILD"}
                            {pax.paxType?.toUpperCase().trim() === "INF" && "INFANT"}
                          </td>
                          <td>
                            {pax.dateOfBirth
                              ? (() => {
                                const [datePart] = pax.dateOfBirth.split(" ");
                                const [day, month, year] = datePart.split("-");
                                const formattedDate = new Date(`${year}-${month}-${day}`);

                                return formattedDate.toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                });
                              })()
                              : pax.dateOfBirth}
                          </td>

                          {/* Uncomment if needed */}
                          {/* <td>{pax.PassportNumber}</td> */}
                        </tr>
                      ))}


                    </tbody>
                  </table>
                </div>
              </div>
              {flightDetails.airBookingResponse[0].customerInfo.passengerTicketDetails != null && flightDetails.airBookingResponse[0].customerInfo.passengerTicketDetails.length > 0 && (
                <div className='col-md-12 col-lg-12'>
                  <h6 className='ruler'>Ticket Information</h6>
                  <div className='table-responsive'>
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th width="15">S.No</th>
                          <th>Passenger Name</th>
                          <th>ETicket-No</th>
                          <th>Status</th>
                        </tr>

                        {flightDetails?.airBookingResponse[0]?.customerInfo?.passengerTicketDetails?.map((pax, index) => (
                          <tr key={index} valign="top">
                            <td>{index + 1}.</td>
                            <td style={{ textTransform: "uppercase" }}>
                              {pax.title}. {pax.firstName} {pax.lastName}
                            </td>
                            <td>{pax.ticketNumber}</td>
                            <td>{pax.status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {flightDetails.ssrDetails != null && flightDetails.ssrDetails.length > 0 && (
                <div className='col-md-12 col-lg-12'>
                  <h6 className='ruler'>Pax SSR Detail</h6>
                  <div className='table-responsive'>
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th width="15">S.No</th>
                          <th>SSR Type</th>
                          <th>Code</th>
                          <th>Description</th>
                          <th>Sector</th>
                          <th>Status</th>
                          <th>Price</th>
                        </tr>

                        {flightDetails?.ssrDetails?.map((item, index) => (
                          <tr key={index} valign="top">
                            <td>{index + 1}</td>
                            <td>{item?.ssrType}</td>
                            <td>{item?.ssrCode}</td>
                            <td>{item?.description}</td>
                            <td className='dropdown-caps'>
                              {item?.departureStation} - {item?.arrivalStation}
                            </td>
                            <td>{item?.status}</td>
                            <td><i className="fa fa-inr" aria-hidden="true"></i> {Number(item?.feeCode || 0).toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              <div className='col-md-12 col-lg-12'>
                <h6 className='ruler'>Payment Information(Fare Summary)</h6>
                <div className='table-responsive'>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Base Fare</th>
                        <th>Taxes</th>
                        <th>SSR Amount</th>
                        <th>Total Fare</th>
                      </tr>
                    </thead>
                    <tbody>
                      {flightDetails.airBookingResponse != null && (
                        <tr>
                          <td>
                            <i className="fa fa-inr" aria-hidden="true"></i>
                            {flightDetails.airBookingResponse[0]?.fareDetails?.totalBaseFare}
                          </td>

                          <td>
                            <i className="fa fa-inr" aria-hidden="true"></i>
                            {flightDetails.airBookingResponse[0]?.fareDetails?.totalOtherTax + flightDetails.airBookingResponse[0]?.fareDetails?.companyMarkUp
                              + flightDetails.airBookingResponse[0]?.fareDetails?.managementFee + +flightDetails.airBookingResponse[0]?.fareDetails?.managementFeeTax}
                          </td>

                          <td>
                            <i className="fa fa-inr" aria-hidden="true"></i>
                            {flightDetails.airBookingResponse[0]?.ssrAmount}
                          </td>

                          <th>
                            <i className="fa fa-inr" aria-hidden="true"></i>
                            {flightDetails.airBookingResponse[0]?.grandTotalFare}
                          </th>
                        </tr>
                      )}
                    </tbody>
                  </table>

                </div>
              </div>

              {flightDetails.airBookingResponse[0].sSRDetails != null && flightDetails.airBookingResponse[0].sSRDetails.length > 0 && (
                <div className='col-md-12 col-lg-12'>
                  <h6 className='ruler'>Baggage Details</h6>
                  <div className='table-responsive'>
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <td>
                            <span>
                              Pax :
                            </span>
                            <span><b> ADT</b></span>
                          </td>
                          <td>
                            <span>
                              Sector :
                            </span>
                            <span><b> DXB - DBR</b></span>
                          </td>
                          <td>
                            <span>
                              Baggage :
                            </span>
                            <span><b> 30 Kg</b></span>
                          </td>
                          <td>
                            <span>
                              Cabin Baggage :
                            </span>
                            <span><b> 07 Kg</b></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {flightDetails.paymentDetails != null && flightDetails.paymentDetails.length > 0 && (
                <div className='col-md-12 col-lg-12'>
                  <h6 className='ruler'>Transaction Summary</h6>
                  <div className='table-responsive'>
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>Payment Status</th>
                          <th>Payment On</th>
                          <th>Payment Mode</th>
                          <th>Amount Paid</th>
                        </tr>

                        <tr>
                          <td>{flightDetails.paymentDetails[0].paymentStatus}</td>
                          <td>{flightDetails.paymentDetails[0].paymentDate} </td>
                          <td>{flightDetails.paymentDetails[0].paymentMode}</td>
                          <th><i class="fa fa-inr" aria-hidden="true"></i> {flightDetails.paymentDetails[0].amountPaid}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <div className='col-md-12 col-lg-12'>
                <h6 className='ruler'>GST Details</h6>
                <div className='table-responsive'>
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Name </th>
                        <th>Number </th>
                        <th>Phone </th>
                        <th>Email </th>
                        <th> Address </th>
                      </tr>
                      <tr>
                        <td>{gstRequest?.name || "NA"}</td>
                        <td>{gstRequest?.gstNumber || "NA"}</td>
                        <td>{gstRequest?.contactNo || "NA"}</td>
                        <td>{gstRequest?.email || "NA"}</td>
                        <td>{gstRequest?.address || "NA"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='col-md-12 col-lg-12'>
                <h6 className='ruler'>User Details</h6>
                <div className='table-responsive'>
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Booking Created By</th>
                        <th>Booking Created On</th>
                      </tr>
                      <tr>
                        <td>{flightDetails.airBookingResponse[0].loggedInUserId}</td>
                        <td data-label="Booking Date">
                          {new Date(flightDetails.airBookingResponse[0].bookingDate)
                            .toLocaleString("en-IN")}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {["TMC Manager","TMC Operations","Corp Travel Manager"].some(role => roles?.includes(role)) && (
                <div className="col-md-12 col-lg-12">
                  <div className="row align-items-center mb-3">
                    <div className="col-md-6">
                      <h6 className="ruler mb-0">Travel Documents</h6>
                    </div>
                    <div className="col-md-6 text-md-end text-start mt-2 mt-md-0">
                      <div className="d-inline-block">
                        <a
                          href="#"
                          className="btn btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#TravelDocuments"
                          onClick={(e) => e.preventDefault()}
                        >
                          + Upload Document
                        </a>
                      </div>
                    </div>
                  </div>

                  {!showDocuments && (
                    <div className="row mb-3">
                      <div className="col-12 d-flex justify-content-center">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleGetDocuments}
                          disabled={loadingDocuments}
                        >
                          {loadingDocuments ? "Loading..." : "Get Documents"}
                        </button>
                      </div>
                    </div>
                  )}

                  {showDocuments && documents.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th>Document Type</th>
                            <th>Document</th>
                            <th>Created By</th>
                            <th>Created On</th>
                          </tr>
                        </thead>
                        <tbody>
                          {documents.map((doc) => (
                            <tr key={doc.id}>
                              <td>{doc.productType}</td>
                              <td>{doc.documentType}</td>
                              <td>
                                <a
                                  href={`${process.env.REACT_APP_API_BASE_URL}/uploads/TravelDocuments/${doc.documentPath}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View
                                </a>
                              </td>
                              <td>{doc.createdBy}</td>
                              <td>{new Date(doc.createdOn).toLocaleString("en-IN")}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    showDocuments && (
                      <div className="alert alert-info text-center">
                        No documents found.
                      </div>
                    )
                  )}
                </div>
              )}

              <div class="col-lg-12 important_info">
                <h4>IMPORTANT INFORMATION</h4>
                <ul>
                  <li>You must web check-in on the airline website and obtain a boarding pass.</li>
                  <li>It is mandatory to wear a mask and carry other protective gear.</li>
                  <li>
                    Reach the terminal at least 2 hours prior to the departure for domestic flight and 4 hours prior to the departure of international flight.
                  </li>
                  <li>For departure terminal please check with the airline first.</li>
                  <li>Date &amp; Time is calculated based on the local time of the city/destination.</li>
                  <li>Use the Airline PNR for all Correspondence directly with the Airline</li>
                  <li>For rescheduling/cancellation within 4 hours of the departure time contact the airline directly</li>
                  <li>
                    Your ability to travel is at the sole discretion of the airport authorities and we shall not be held responsible.
                  </li>

                </ul>
              </div>
            </>
          ) : (
            !loading && flightDetails && (
              <>
                <div class="row mamage_depo">
                  <div class="col-lg-12">
                    <h6 className='ruler'>Flight Booking Details</h6>
                  </div>
                  <div class="col-lg-12">
                    <p className=''>No Flight Booking Details Found !!</p>
                  </div>
                </div>
              </>
            )
          )}
        </div>
      </section>

      <div className="modal fade" id="EmailTicket" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">Send Ticket to Email Address</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              {/* <EmailTicket></EmailTicket> */}

              <EmailTicket
                referenceNo={flightDetails?.referenceNo}
                trackId={flightDetails?.airBookingResponse[0]?.flightDetails[0]?.trackID}
              />

            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="SMSTicket" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">Send Ticket by SMS</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              <SmsTicket
                referenceNo={flightDetails?.referenceNo}
                trackId={flightDetails?.airBookingResponse[0]?.flightDetails[0]?.trackID}
              />
            </div>
          </div>
        </div>
      </div>


      <div className="modal fade" id="WhatsAppMe" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">Send Ticket on WhatsApp</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <div className="modal-body">
              <WhatsAppTicket></WhatsAppTicket>
            </div>



          </div>
        </div>
      </div>

      <div className="modal fade" id="TravelDocuments" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">Upload Travel Document</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              <TravelDocument
                referenceNo={flightDetails?.referenceNo}
                trackId={flightDetails?.airBookingResponse[0]?.flightDetails[0]?.trackID}
                userName={userName}
              />

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionDetails;